// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ name: string; value: string }>;

export const DispatchUpdateWarehousesSourcingTypes: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/CheckoutReviewAndSubmit/UpdateWarehousesSourcingTypes",
        warehousesSourcingType: { name: props.parameter.name, value: props.parameter.value },
    });
};

export const chain = [DispatchUpdateWarehousesSourcingTypes];

const updateWarehousesSourcingTypes = createHandlerChainRunner(chain, "UpdateWarehousesSourcingTypes");
export default updateWarehousesSourcingTypes;
